<template>
 <div class="fluid">
    <b-row>
        <b-col sm="12" md="12">
            <CardFiltrosPesquisa v-show="!lista.length" @pesquisar="pesquisar" @reset="reset"/>
        </b-col>
    </b-row>
    <b-row>
        <b-col sm="12" md="12">
            <div v-if="pesquisando" class="app d-flex flex-row justify-content-center align-items-center loading pt-4">
                <b-spinner variant="primary" label="Pesquisando."></b-spinner>
                <strong>&nbsp;Pesquisando.</strong>
            </div>
            <ListaConsulta v-if="lista.length" :lista="lista" :filtros="filtros" @voltar="reset" />
        </b-col>
    </b-row>
    <b-row>
        <b-col sm="12" md="12">
            <p class="text-danger" style="padding-top: 30px; font-size: 16px; text-align: center" v-if="nenhumResultado"><b>Nenhum resultado encontrado</b></p>
        </b-col>
    </b-row>    
</div>  
</template>

<script>
import CardFiltrosPesquisa from './components/_CardFiltrosPesquisa'
import ListaConsulta from './components/_ListaConsulta'
import servicoRpv from '@/api/rpv'
import debug from '@/util/debug'

const fnm = 'transp/consultaRpv.vue'

export default {
    components: {
        CardFiltrosPesquisa,
        ListaConsulta
    },
    data() {
        return {
            nenhumResultado: false,
            pesquisando: false,
            filtros: {},
            lista: []
        }
    },
    methods: {
        pesquisar(filtros) {
            let mtd = 'pesquisar'
      	    debug(null, mtd, fnm)
            this.nenhumResultado = false            
            this.filtros = Object.assign({}, filtros)
            this.pesquisando = true

            servicoRpv.consPortalTransp(filtros)
            .then(res => {
                debug('Consulta OK', mtd, fnm)
                this.lista = res.data

                if(!this.lista.length)
                    this.nenhumResultado = true
            })
            .catch(res => {
                debug(`Consulta ERRO [${JSON.stringify(res)}]`, mtd, fnm)
                this.mensagemDeErroGenerica(res)
            })
            .finally((e) => {
                this.pesquisando = false
            })
        },
        reset() {
            debug(null, 'reset', fnm)
            this.nenhumResultado = false
            this.lista = []
        }
    }
}
</script>

<style>
</style>
